import { render, staticRenderFns } from "./CampaignsGridHeadline.vue?vue&type=template&id=fea3ffca"
import script from "./CampaignsGridHeadline.vue?vue&type=script&lang=ts"
export * from "./CampaignsGridHeadline.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsGridHeadline.vue?vue&type=style&index=0&id=fea3ffca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports